/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Component, Input} from '@angular/core';

import {PageCollectionService} from './providers/page-collection';
import {WizardNavigationService} from './providers/wizard-navigation';
import {WizardPage} from './wizard-page';
export class WizardStepnavItem {
public page: WizardPage;
/**
 * @param {?} navService
 * @param {?} pageCollection
 */
constructor(public navService: WizardNavigationService,
public pageCollection: PageCollectionService) {}
/**
 * @return {?}
 */
private pageGuard(): void {
        if (!this.page) {
            throw new Error("Wizard stepnav item is not associated with a wizard page.");
        }
    }
/**
 * @return {?}
 */
public get id(): string {
        this.pageGuard();
        return this.pageCollection.getStepItemIdForPage(this.page);
    }
/**
 * @return {?}
 */
public get isDisabled(): boolean {
        this.pageGuard();
        return this.page.disabled || this.navService.wizardStopNavigation || this.navService.wizardDisableStepnav;
    }
/**
 * @return {?}
 */
public get isCurrent(): boolean {
        this.pageGuard();
        return this.page.current;
    }
/**
 * @return {?}
 */
public get isComplete(): boolean {
        this.pageGuard();
        return this.page.completed;
    }
/**
 * @return {?}
 */
public get canNavigate(): boolean {
        this.pageGuard();
        return this.pageCollection.previousPageIsCompleted(this.page);
    }
/**
 * @return {?}
 */
click(): void {
        this.pageGuard();

        // if we click on our own stepnav or a disabled stepnav, we don't want to do anything
        if (this.isDisabled || this.isCurrent) {
            return;
        }

        this.navService.goTo(this.page);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "[clr-wizard-stepnav-item]",
    template: `
        <button type="button" class="btn btn-link clr-wizard-stepnav-link" (click)="click()">
            <ng-template [ngTemplateOutlet]="page.navTitle"></ng-template>
        </button>
    `,
    host: {
        "[id]": "id",
        "[attr.aria-selected]": "isCurrent",
        "[attr.aria-controls]": "id",
        "role": "presentation",
        "[class.clr-nav-link]": "true",
        "[class.nav-item]": "true",
        "[class.active]": "isCurrent",
        "[class.disabled]": "isDisabled",
        "[class.no-click]": "!canNavigate",
        "[class.complete]": "isComplete"
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: WizardNavigationService, },
{type: PageCollectionService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'page': [{ type: Input, args: ["page", ] },],
};
}

function WizardStepnavItem_tsickle_Closure_declarations() {
/** @type {?} */
WizardStepnavItem.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WizardStepnavItem.ctorParameters;
/** @type {?} */
WizardStepnavItem.propDecorators;
/** @type {?} */
WizardStepnavItem.prototype.page;
/** @type {?} */
WizardStepnavItem.prototype.navService;
/** @type {?} */
WizardStepnavItem.prototype.pageCollection;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
